<template>
  <div class="searchPage">
    <div class="searchForm">
      <form action="/">
        <van-search
          v-model="keyword"
          placeholder="逝者姓名/纪念馆编号/建馆人"
          show-action
          clearable
          background="#24a378"
          @search="onSearch"
          @cancel="onCancel"
        />
      </form>
    </div>
    <div>
      <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
        <van-list
        v-model="loading"
        :finished="finished"
        :offset="offset"
        :immediate-check="ischeck"
        finished-text="没有更多了"
        @load="loadMore">
          <div v-for="item in dataList" :key="item.id">
            <div class="search-list2">
              <router-link  class="search-list van-hairline--bottom aaa" :to="{path:'/MemorialHall?id='+ item.SerialNumber}">
                <div class="hd">
                  <div class="image">
                    <van-image
                      radius="4px"
                      fit="cover"
                      v-bind:src="item.DeceasedPhotoPath"
                    />
                  </div>
                </div>
                <div class="bd">
                  <h2 class="title">{{item.DeceasedFullName}}</h2>
                  <p class="des van-ellipsis">建馆人：{{item.MemberNickName}}</p>
                  <p class="des van-ellipsis">{{item.DeceasedLifeIntroduction.length > 0 ? item.DeceasedLifeIntroduction:'暂无生平简介......'}}</p>
                </div>
              </router-link>
              <div class="ft rightpadding">
                <van-button v-if="item.IsRelative" color="#999" @click="clickfollow(item)" size="small">已关注</van-button>
                <van-button v-else type="danger" @click="clickfollow(item)" size="small">+ 关注</van-button>
              </div>
            </div>
          
        </div>
        </van-list>
      
      </van-pull-refresh>
    </div>
    <!-- <div>
      <router-link class="search-list van-hairline--bottom" to="/MemorialHall" v-for="item in 10" :key="item.id">
        <div class="hd">
          <div class="image">
            <van-image
              radius="4px"
              fit="cover"
              src="https://img.yzcdn.cn/vant/cat.jpeg"
            />
          </div>
        </div>
        <div class="bd">
          <h2 class="title">王大海因病去世</h2>
          <p class="des van-ellipsis">建馆人：张三</p>
          <p class="des van-ellipsis">刘登海四川广安因癌症导致器官衰竭于2015年6月17日6点08分逝世，享年73岁。</p>
        </div>
        <div class="ft">
          <van-button v-if="item == 1" color="#999" size="small">已关注</van-button>
          <van-button v-else type="danger" size="small">+ 关注</van-button>
        </div>
      </router-link>
    </div> -->


  </div>
</template>

<script>
  import { Toast } from 'vant';
  import { mapGetters } from 'vuex'
  
  export default {
    data() {
      return {
        refreshing: false,
        loading: true,
        finished: false,
        offset: 100,
        ischeck: false,
        options: null,
        dataList: [],
        keyword:''
      }
    },
    computed:{
      ...mapGetters(['currentToken'])
    },
    components: {
    },
    created(){
      
    },
    activated(){
      this.init();
    },
    methods: {
      onCancel() {
        this.$router.go(-1)
      },
      onSearch(){
        this.init();
      },
      init() {
        var that = this;
        that.options = {
          type: "getSearchMemorialHallList",
          pageIndex: 1,
          keyword: that.keyword,
        };
        that.getList();
      },
      loadMore() {
        Object.assign(this.options, {
          pageIndex: this.options.pageIndex + 1,
          keyword : this.keyword,
        });
        this.loading = true;
        this.getList();
      },
      onRefresh() {
        var _this = this;
        this.finished = false;
        // 重新加载数据
        // 将 loading 设置为 true，表示处于加载状态
        this.loading = true;
        Object.assign(this.options, {
          pageIndex: 1,
          keyword : _this.keyword,
        });
        this.getList();
      },
      getList() {
        var that = this;
        this.$store.dispatch(this.options).then(
          res => {
            that.loading = false;
            if (that.refreshing) {
              that.refreshing = false;
            }

            var dataList = res.MemorialHallList;
            if (dataList.length <= 0) {
              that.finished = true;
            }

            if (dataList.length < 10){
              that.finished = true;
            }

            if (this.options.pageIndex > 1) {
              if (dataList.length > 0) {
                dataList.forEach(element => {
                  that.dataList.push(element);
                });
              }
            } 
            else {
              that.dataList = dataList;
            }
          },
          error => {}
        );
      },
      clickfollow(item){
        //addFollowMemorialHall
        if(!(this.currentToken && this.currentToken.isLogin)){
          Toast('请登录后再进行关注');
          return ;
        }
         var that = this;
         this.$store.dispatch({
           type : "addFollowMemorialHallVue",
           "IsAuth" : true,
           "MId" : item.MemorialHallID
         }).then(
           res => {
             Toast(res.Message);
             if(res.IsSuccess){
               item.IsRelative = res.Information == "true";
             }
           },
           error => {}
         );
      }
    }
  }
</script>

<style scoped>
.search-list2{
  display: flex;
  align-items: center;
}
.aaa{
  flex: 1
}
.rightpadding{
  margin-right: 10px;
}
.van-search__action{
  color: #fff !important;
}
</style>